"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MmxlGetter = (function () {
    function MmxlGetter() {
    }
    MmxlGetter.setMmxl = function (mmxl) {
        MmxlGetter._mmxl = mmxl;
    };
    MmxlGetter.getRateCard = function (medium, options) {
        return MmxlGetter._mmxl.getRateCard(medium, options);
    };
    MmxlGetter.getFrequencyCappingKits = function (frequencyCappingKitId) {
        return MmxlGetter._mmxl.getFrequencyCappingKit(frequencyCappingKitId);
    };
    MmxlGetter.getTargetingKits = function (targetingKitId) {
        return MmxlGetter._mmxl.getTargetingKit(targetingKitId);
    };
    return MmxlGetter;
}());
exports.MmxlGetter = MmxlGetter;
//# sourceMappingURL=mmxlGetter.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/datalayerHelpers/mmxlGetter.js
// module id = 44
// module chunks = 0